module.exports = __webpack_public_path__ + "img/icon1.3e395d0d.png";